import { takeEvery, takeLatest, put } from 'redux-saga/effects';

import { GET_PROFILE, UPDATE_PROFILE } from './constants';
import { requestProfile, requestUpdateProfile } from './api';
import { getProfileSuccess, updateProfileSuccess, updateProfileFailure } from './actions';

/**
 *
 * @returns {IterableIterator<PutEffect<{profile: *, type: string}>>}
 */
function* getProfile() {
    const profile = yield requestProfile();
    if ( profile ) {
        yield put( getProfileSuccess( profile ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{profile, type}>>}
 */
function* updateProfile(actionObj) {
    const { resolve, reject } = actionObj;

    try {
        const response = yield requestUpdateProfile(actionObj.formData);
        if (response.success) {
            yield put(updateProfileSuccess(response.profile));
            resolve(response);
        } else {
            if (response.errors) {
                yield put(updateProfileFailure(response.errors));
                reject(response.errors);
            }
        }
    } catch (error) {
        console.log("error " + error);
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchProfile() {
    yield takeEvery( GET_PROFILE, getProfile );
    yield takeLatest( UPDATE_PROFILE, updateProfile);
}

export default watchProfile;